import React, { useState, useEffect, useCallback } from "react";
import { Card, Table, Button, Modal, Spin, Tag } from "antd";
import { FolderOpenOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import employeeDocumentFolderService from "Services/EmployeeDocumentFolderService";
import EmployeeDocumentFolderView from "./EmployeeDocumentFolderView";

// HR Received Documents panel (per Mudassir's Jun-17 handoff). Lists employees
// who have a document folder and opens the full folder for a selected one.
// Rendered as the "Received Documents" tab inside Document Storage.
function ReceivedDocuments() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null); // selected employee row
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchEmployees = useCallback(async () => {
    setLoading(true);
    try {
      const data = await employeeDocumentFolderService.getEmployeesWithFolders();
      setEmployees(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error loading employees with document folders:", err);
      toast.error("Failed to load employees");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  const openFolder = (record) => {
    setSelected(record);
    setIsModalOpen(true);
  };

  const columns = [
    {
      title: "Employee",
      key: "employee",
      render: (_, r) => (
        <div>
          <div style={{ fontWeight: 500 }}>{r.employeeName}</div>
          <div style={{ fontSize: "0.8rem", color: "rgba(0,0,0,0.45)" }}>
            {r.publicId || r.workEmail || r.personalEmail || ""}
          </div>
        </div>
      ),
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      render: (v) => v || "-",
    },
    {
      title: "Job Title",
      dataIndex: "jobTitleName",
      key: "jobTitleName",
      render: (v) => v || "-",
    },
    {
      title: "Designation",
      dataIndex: "designationName",
      key: "designationName",
      render: (v) => v || "-",
    },
    {
      title: "Document Groups",
      dataIndex: "sourceGroupCount",
      key: "sourceGroupCount",
      render: (v) => <Tag color="blue">{v ?? 0}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, r) => (
        <Button className="btn-primary" icon={<FolderOpenOutlined />} onClick={() => openFolder(r)}>
          View Folder
        </Button>
      ),
    },
  ];

  return (
    <>
      <Card title="Received Documents" bordered={false} className="card-professional">
        {loading ? (
          <Spin />
        ) : (
          <Table
            className="custom-table"
            dataSource={employees}
            columns={columns}
            rowKey={(r) => r.employeeId}
            pagination={false}
            locale={{ emptyText: "No employees have document folders yet." }}
          />
        )}
      </Card>

      <Modal
        title={selected ? `Documents - ${selected.employeeName}` : "Employee Documents"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={760}
        zIndex={2000}
        destroyOnClose
      >
        {selected && <EmployeeDocumentFolderView employeeId={selected.employeeId} />}
      </Modal>
    </>
  );
}

export default ReceivedDocuments;
